import { render, staticRenderFns } from "./checkUpDetail.vue?vue&type=template&id=6e7a81d5"
import script from "./checkUpDetail.vue?vue&type=script&lang=js"
export * from "./checkUpDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7a81d5')) {
      api.createRecord('6e7a81d5', component.options)
    } else {
      api.reload('6e7a81d5', component.options)
    }
    module.hot.accept("./checkUpDetail.vue?vue&type=template&id=6e7a81d5", function () {
      api.rerender('6e7a81d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkUpDetail.vue"
export default component.exports